import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { OtpService } from '../../services/otp.service';
import { LocaleService } from '../../services/locale.service';

@Component({
  selector: 'app-otp',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    AsyncPipe
  ],
  templateUrl: './otp.component.html',
  styleUrl: './otp.component.css'
})
export class OtpComponent implements OnInit {
  @ViewChild('otpFormElement') otpFormElement!: ElementRef;
  otpForm!: FormGroup;
  initialInfo$!: Observable<string | boolean>;
  otpService = inject(OtpService);
  localeService = inject(LocaleService);
  private fb = inject(FormBuilder);
  localStorage: Storage = localStorage

  ngOnInit(): void {
    this.createOtpFormGroup();
    this.localeService.setOtp(this.otpService.getLocale());
  }

  createOtpFormGroup() {
    const validatorSet = [Validators.required, Validators.pattern(/^\d$/)];
    const formConfig = {
      digit1: ['', [...validatorSet]],
      digit2: ['', [...validatorSet]],
      digit3: ['', [...validatorSet]],
      digit4: ['', [...validatorSet]],
      digit5: ['', [...validatorSet]],
      digit6: ['', [...validatorSet]]
    };
    this.otpForm = this.fb.group(formConfig);
  }

  hasError() {
    const { invalid, touched } = this.otpForm
    return invalid && touched
  }

  //revisa si es o no un número, si es cadena se borra el valor del input
  onInput(value: string, formControl: string) {
    if (!/^\d$/.test(value)) {
      this.otpForm.get(formControl)?.setValue('');
    } else {
      this.otpForm.get(formControl)?.setValue(value);
      this.navigateToNextDigitBox(formControl);
    }
  }

  navigateToNextDigitBox(currentControl: string) {
    const nextControl = this.getFormControlOnNavigation(currentControl, "next");
    const nextInput = this.otpFormElement.nativeElement.querySelector(`[formControlName="${nextControl}"]`);

    //hace foco y limpia el siguiente input
    if (this.otpForm.get(nextControl)) {
      this.otpForm.get(nextControl)?.setValue("");
      nextInput.focus();
    }
  }

  checkPossibleBackstep(event: Event, currentControl: string) {
    let keyboardEvent = event as KeyboardEvent;
    if(keyboardEvent.key === "Backspace" && this.otpForm.get(currentControl)?.value.length === 0 
    || keyboardEvent.key === "Delete" && this.otpForm.get(currentControl)?.value.length === 0) {
      const previousControl = this.getFormControlOnNavigation(currentControl, "back");
      const previousInput = this.otpFormElement.nativeElement.querySelector(`[formControlName="${previousControl}"]`);

      if(this.otpForm.get(previousControl)) {
        previousInput.focus();
      }
    }
  }

  getFormControlOnNavigation(currentControl: string, step: string) {
    let digit
    if(step === "next") {
      digit = parseInt(currentControl.charAt(currentControl.length - 1)) + 1;
    }
    if(step === "back") {
      digit = parseInt(currentControl.charAt(currentControl.length - 1)) - 1;
    }
    
    let formControlName = currentControl.slice(0, -1) + digit;
    return formControlName;
  }

  getOtp () {
    return `${this.otpForm.get('digit1')?.value}${this.otpForm.get('digit2')?.value}${this.otpForm.get('digit3')?.value}${this.otpForm.get('digit4')?.value}${this.otpForm.get('digit5')?.value}${this.otpForm.get('digit6')?.value}`
  }

  resetForm() {
    const firstInput = this.otpFormElement.nativeElement.querySelector(`[formControlName="digit1"]`);
    this.otpForm.reset()
    firstInput.focus();
  }

  onSubmit() {
    if(!this.otpForm.invalid) {
      this.otpService.postOtp(this.getOtp());
      this.resetForm();
    }
  }
}
